import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated"); // or use a context or cookie/session

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
